/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Lifecycle_Archive_Product_TitleInputs */

const en_lifecycle_archive_product_title = /** @type {(inputs: Lifecycle_Archive_Product_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Archive ${i?.name}?`)
};

const de_lifecycle_archive_product_title = /** @type {(inputs: Lifecycle_Archive_Product_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} archivieren?`)
};

/**
* | output |
* | --- |
* | "Archive {name}?" |
*
* @param {Lifecycle_Archive_Product_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lifecycle_archive_product_title = /** @type {((inputs: Lifecycle_Archive_Product_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lifecycle_Archive_Product_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_lifecycle_archive_product_title(inputs)
	return en_lifecycle_archive_product_title(inputs)
});